import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useIdleTimer } from "react-idle-timer";
import { useState, useRef } from "react";

const SessionTimeout = () => {
  const [counterpopup, setCounterPopup] = useState(false);
  const [timer, setTimer] = useState("30:00");
  const anchor = useRef<any>(null);
  const [logOutClassName, setLogOutClassName] = useState(
    "btn-common white-btn"
  );

  const handleOnIdle = () => {
    if (!counterpopup) {
      setCounterPopup(true);
      clearTimer(getDeadTime(600));
    }
  };
  
  const handleOnActive = (event: any) => {};

  const handleOnAction = (event: any) => {
    // Send remaining time to active the another tab when current tab is active
    idleTimer.message({ remainingTime: idleTimer.getRemainingTime() }, false);
  };

  const handleTimerMessages = (message: any) => {
    // Recieved when user click on "I'm here"
    if (message.resetSession) {
      hideCounterPopup(true);
    }
    // Recieved to reset the timer if user active on another tab
    else if (
      message.remainingTime &&
      idleTimer.getRemainingTime() < message.remainingTime
    ) {
      idleTimer.reset();
    }
  };

  const getDeadTime = (seconds: any) => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + seconds);
    return deadline;
  };

  const getTimeRemaining = (e: Date | string) => {
    const endTime = typeof e === "string" ? Date.parse(e) : e.getTime();
    const total = endTime - new Date().getTime();
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    return { minutes, seconds };
  };

  const startTimer = (e: any) => {
    let { minutes, seconds } = getTimeRemaining(e);
    if (minutes >= 0 && seconds >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    } else {
      Logout();
    }
  };

  const clearTimer = (e: any) => {
    setTimer("30:00");
    if (anchor.current) clearInterval(anchor.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    anchor.current = id;
  };

  function hideCounterPopup(dontSendMessage: any) {
    setCounterPopup(false);
    clearTimer(getDeadTime(1800));

    // If the counter popup hide here then hide it on all another tabs as well
    if (!dontSendMessage) {
      idleTimer.message({ resetSession: true }, false);
    }
  }

  function resetSession() {
    hideCounterPopup(false);
  }

  const Logout = () => {
    // if (sessionResp) {
    //   checkUserSessionFromClient();
    // } else {
    logout();
    // }
  };
  const logout = () => {
    // Clear user session data
    sessionStorage.clear();
    localStorage.setItem("logout", Date.now().toString());

    // Clear local storage data
    localStorage.removeItem("logout");
    localStorage.clear();
    window.location.href = "/login";
  };

  const idleTimer = useIdleTimer({
    timeout: 1000 * 60 * 5,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    crossTab: true,
    onMessage: handleTimerMessages,
    debounce: 500,
  });

  function showCounterPopup() {
    setCounterPopup(true);
  }

  return (
    <>
      {counterpopup && (
        <Dialog
          className="xs-modal width-given"
          title={"Session Expire Time"}
          onClose={resetSession}
        >
          <b>Are you still there?</b> If not, your session will close in:{" "}
          <b>{timer}</b> due to inactivity.
          <DialogActionsBar>
            <button className="btn-common btn-green" onClick={resetSession}>
              {" "}
              I'm here
            </button>
            <button
              className={logOutClassName}
              onClick={Logout}
              onMouseEnter={() => setLogOutClassName("btn-common btn-green")}
              onMouseLeave={() => setLogOutClassName("btn-common white-btn")}
            >
              Log out
            </button>
          </DialogActionsBar>
        </Dialog>
      )}
    </>
  );
};

export default SessionTimeout;
